"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChainConfiguration = exports.MANA_GRAPH_BY_CHAIN_ID = void 0;
const chain_id_1 = require("@dcl/schemas/dist/dapps/chain-id");
const provider_type_1 = require("@dcl/schemas/dist/dapps/provider-type");
const configuration_1 = require("decentraland-connect/dist/configuration");
const RPC_URLS = (0, configuration_1.getRpcUrls)(provider_type_1.ProviderType.NETWORK);
exports.MANA_GRAPH_BY_CHAIN_ID = {
    [chain_id_1.ChainId.ETHEREUM_MAINNET]: 'https://api.thegraph.com/subgraphs/name/decentraland/mana-ethereum-mainnet',
    [chain_id_1.ChainId.ETHEREUM_ROPSTEN]: 'https://api.thegraph.com/subgraphs/name/decentraland/mana-ethereum-ropsten',
    [chain_id_1.ChainId.ETHEREUM_GOERLI]: 'https://api.thegraph.com/subgraphs/name/decentraland/mana-ethereum-goerli',
    [chain_id_1.ChainId.ETHEREUM_RINKEBY]: 'https://api.thegraph.com/subgraphs/name/decentraland/mana-ethereum-rinkeby',
    [chain_id_1.ChainId.ETHEREUM_SEPOLIA]: 'https://api.studio.thegraph.com/query/49472/mana-ethereum-sepolia/version/latest',
    [chain_id_1.ChainId.MATIC_MAINNET]: 'https://api.thegraph.com/subgraphs/name/decentraland/mana-matic-mainnet',
    [chain_id_1.ChainId.MATIC_MUMBAI]: 'https://api.thegraph.com/subgraphs/name/decentraland/mana-matic-mumbai'
};
function getChainConfiguration(chainId) {
    return {
        network: (0, chain_id_1.getNetwork)(chainId),
        manaGraphURL: exports.MANA_GRAPH_BY_CHAIN_ID[chainId],
        rpcURL: RPC_URLS[chainId],
        networkMapping: (0, chain_id_1.getNetworkMapping)(chainId)
    };
}
exports.getChainConfiguration = getChainConfiguration;
//# sourceMappingURL=chainConfiguration.js.map